import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCardComparisonHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${toRem(16)};
  text-align: center;

  .comparison-page-header__action {
    display: flex;
    width: 100%;
  }

  .comparison-page-header__action--top {
    justify-content: center;
    @media ${baseVariables.mediaQuery.md} {
      justify-content: flex-start;
    }
  }

  .comparison-page-header__action--bottom {
    justify-content: center;
  }
`;
